import script from "./imageLabelGalleryMultiple.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./imageLabelGalleryMultiple.component.vue?vue&type=script&lang=ts&setup=true"

import "./imageLabelGalleryMultiple.component.vue?vue&type=style&index=0&id=0fa19adc&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fa19adc"]])

export default __exports__